var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CM2HumidityMeasurement',_vm._b({},'CM2HumidityMeasurement',_vm.$props,false)),(_vm.brightness)?_c('MeasurementItem',{attrs:{"title":_vm.brightness.title,"datetime":_vm.brightness.lastUpdated,"link-to":{
            name: 'charts',
            params: {
                id: _vm.tracker.id,
                dataType: _vm.brightness.key,
            },
        }},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('BrightnessIcon',{attrs:{"width":"24","height":"24"}})]},proxy:true},{key:"content",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('shared.measurements.brightness'))+": "),_c('h3',[_vm._v(_vm._s(_vm.brightness.value))])]},proxy:true}],null,false,1381560009)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }